export default __webpack_public_path__ + "static/media/edition.28d92c93.png";